export function CustomerPaymentCtrl (
  $scope,
  companyMessages,
  customer,
  dateParsing,
  inheritorApi,
  integrations,
  lostTerminalTransaction,
  payment,
  pos_terminals
) {

  $scope.customer      = customer || {};
  $scope.integrations  = integrations;
  $scope.pos_terminals = pos_terminals;

  $scope.customer_payment = payment || {
    id                                 : '',
    customer_id                        : $scope.customer.id,
    customer_payment_number            : '',
    reference                          : '',
    post_date                          : dateParsing.today(),
    status                             : 'O',
    applied_amount                     : 0.00,
    amount                             : 0.00,
    note                               : '',
    pos_terminal_id                    : $scope.pos_terminals.length ? ($scope.pos_terminals.length === 1 ? $scope.pos_terminals[0].id : $scope.user.default_pos_terminal_id) : '',
    pos_terminal_type                  : $scope.pos_terminals.length ? ($scope.pos_terminals.length === 1 ? $scope.pos_terminals[0].terminal_type : $scope.user.default_pos_terminal_type) : '',
    moto                               : false,
    customer_payment_methods_attributes: [],
    customer_payment_items_attributes  : [{
      id                 : '',
      customer_payment_id: '',
      invoice_id         : '',
      invoice_number     : '',
      invoice_post_date  : '',
      invoice_total      : 0.00,
      amount             : 0.00,
      invoice_balance_due: 0.00,
      untouched          : true,
      getBalance () {
        var invoice_balance_due = new BigDecimal( this.invoice_balance_due ? this.invoice_balance_due.toString(): '0' ).setScale(2, BigDecimal.ROUND_HALF_UP);
        var amount              = new BigDecimal( this.amount ? this.amount.toString(): '0' ).setScale(2, BigDecimal.ROUND_HALF_UP);

        if (invoice_balance_due.isLessThanOrEqualTo(BigDecimal.ZERO)) {
          return 0;
        }
        return invoice_balance_due.subtract(amount).toString();
      }
    }]
  };

  $scope.companyMessages = companyMessages;

  inheritorApi.inheritCtrl('CustomerPaymentLiteCtrl', $scope);

  if (payment) {
    $scope.addCalcFunctions();
  }

  if (lostTerminalTransaction) {
    $scope.handleLostTerminalTransaction();
  }
}
